import svg from './row-svg/tri-alphabetique-v3.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function TriAlphabetiqueV3Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default TriAlphabetiqueV3Icon;
